import type { ReactNode } from 'react';

export type ModalMode = 'centered' | 'bottom-sheet';

export type ModalProps = {
  isShow: boolean;
  children: ReactNode;
  isBackdrop?: boolean;
  onBackdropDismiss?: (closeModal: () => void) => void;
  className?: string;
  containerClassName?: string;
  /**
   * Layout mode of the modal body.
   * - `centered` (default) keeps the existing centered, fixed-width modal.
   * - `bottom-sheet` pins the body to the bottom on mobile (full-width with
   *   rounded top corners) and centers a wider modal on desktop.
   */
  mode?: ModalMode;
  /** Disables backdrop click and ESC dismissal for blocking flows. Defaults to `true`. */
  isDismissible?: boolean;
};

export enum ModalType {
  Auth = 'auth',
  BirthDate = 'birth-date',
  DeliveryAddress = 'delivery-address',
  DeliveryAddressList = 'delivery-address-list',
  DeliveryInfo = 'delivery-info',
  ChangeEmail = 'change-email',
  ChangeName = 'change-name',
  Comment = 'comment',
  ProductDetails = 'product-details',
  ChangeNotifications = 'change-notifications',
  Promocode = 'promocode',
  AddCard = 'add-card',
  DeleteAccount = 'delete-account',
  Logout = 'logout',
  DeleteAddress = 'delete-address',
  DeleteCard = 'delete-card',
  SelectDate = 'select-date',
  SelectDateCD = 'select-date-cd',
  Feedback = 'feedback',
  FeedbackSuccess = 'feedback-success',
  CreateReview = 'create-review',
  AgeRestriction = 'age-restriction',
  RateApp = 'rate-app',
  Recommendations = 'recommendations',
  CheckoutReciever = 'reciever-data',
  CheckoutAddRecieverData = 'add-reciever-data',
  Check3Ds = 'check-3ds',
  ReferralProgram = 'referral-program',
  SelectSKU = 'select-sku',
  Subscription = 'subscription',
  SubscriptionOff = 'subscription-off',
  EditAddressLocation = 'edit-address-location',
  EditAddressDetails = 'edit-address-details',
  OutOfZone = 'out-of-zone',
  DokobitVerification = 'dokobit-verification',
  TransactionDetails = 'transaction-details',
  Refund = 'refund',
  Geofencing = 'geofencing',
  DeliveryMethodChange = 'delivery-method-change',
  CheckoutDestination = 'checkout-destination',
}
